import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactJson from "react-json-view";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  SG_FETCH_DEBRIEF_PDF_REPORT,
  SG_UPDATE_DEBRIEF_PDF_REPORT,
  SG_DELETE_DEBRIEF_PDF_REPORT,
  RESET_DEBRIEF_PDF_REPORT,
  SG_GENERATE_SECURE_AWS_S3_DEBRIEF_PDF_REPORT_LINK,
  SG_REGENERATE_DEBRIEF_PDF_REPORT,
} from "constants/actions";
//
import { Icon, Button, Header, List } from "semantic-ui-react";
//
import { format } from "date-fns";
import ReplacePdfFile from "./ReplacePdfFile";
//
//
const Details = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [templateId, setTemplateId] = useState(false);
  const [templateDetails, setTemplateDetails] = useState(null);
  // emailRef removed — kept earlier during experimentation but not used
  const [downloadLink, setDownloadLink] = useState(false);

  function BackArrow() {
    navigate(`/app/pdf-reports`);
  }

  useEffect(() => {
    setTemplateId(id);
  }, [id]);

  useEffect(() => {
    if (templateId) {
      dispatch({
        type: SG_FETCH_DEBRIEF_PDF_REPORT,
        payload: { id: templateId },
      });
    }
  }, [dispatch, templateId]);

  const { get_debrief_pdf_report } = useSelector(
    (state) => ({
      get_debrief_pdf_report: state.debrief_pdf_report,
    }),
    shallowEqual
  );

  useEffect(() => {
    // Only navigate on update if it's not a file replacement
    // File replacement will refresh data in place
    if (get_debrief_pdf_report?.updated && !get_debrief_pdf_report?.updated?.new_file) {
      navigate(`/app/pdf-reports`);
    }
  }, [get_debrief_pdf_report, navigate]);

  useEffect(() => {
    setTemplateDetails(get_debrief_pdf_report?.[templateId]);
  }, [get_debrief_pdf_report, templateId]);

  useEffect(() => {
    setDownloadLink(get_debrief_pdf_report?.aws_s3_link);
  }, [get_debrief_pdf_report]);

  function RemoveFile(delete_share_id) {
    //  SG_UPDATE_DEBRIEF_PDF_REPORT

    if (templateId && delete_share_id) {
      dispatch({
        type: RESET_DEBRIEF_PDF_REPORT,
      });
      dispatch({
        type: SG_UPDATE_DEBRIEF_PDF_REPORT,
        payload: { id: templateId, delete_share_id: delete_share_id },
      });
    }
  }
  console.log("get_debrief_pdf_report?.aws_s3_link", get_debrief_pdf_report?.aws_s3_link);

  // SG_DELETE_DEBRIEF_PDF_REPORT
  function DeleteRow() {
    //  SG_DELETE_DEBRIEF_PDF_REPORT
    if (templateId) {
      dispatch({
        type: RESET_DEBRIEF_PDF_REPORT,
      });
      dispatch({
        type: SG_DELETE_DEBRIEF_PDF_REPORT,
        payload: { id: templateId },
      });
    }
  }

  // SG_GENERATE_SECURE_AWS_S3_DEBRIEF_PDF_REPORT_LINK
  function GenerateLink() {
    if (templateId) {
      dispatch({
        type: SG_GENERATE_SECURE_AWS_S3_DEBRIEF_PDF_REPORT_LINK,
        payload: { id: templateId },
      });
    }
  }

  function RegeneratePdfReport() {
    if (templateId) {
      dispatch({
        type: SG_REGENERATE_DEBRIEF_PDF_REPORT,
        payload: { id: templateId },
      });
    }
  }

    function QueuePdfReport() {
    if (templateId) {
      dispatch({
        type: SG_UPDATE_DEBRIEF_PDF_REPORT,
        payload: { id: templateId, status: 5 },
      });
    }
  }


  function ViewFile() {
 
      window.open(downloadLink?.url, "_blank");
    
  }

  return (
    <>
      <Header as="h2">
        <Icon
          style={{ cursor: "pointer" }}
          onClick={BackArrow}
          name="arrow left"
        />
        Details of {templateDetails?.organization} #{" "}
        {templateDetails?.organization_name}
      </Header>
      <SingleRowContent>
        <span>
          Created By Employee {templateDetails?.employee} #{" "}
          {templateDetails?.employee_name} - {templateDetails?.employee_email}
        </span>
      </SingleRowContent>
      <SectionDiv>
        <Container>
          <List horizontal>
            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Status</List.Header>
                  {templateDetails?.status} # {templateDetails?.status_text}
                  <Button
                    color="orange"
                    size="tiny"
                    onClick={RegeneratePdfReport}
                  >
                    Re Generate
                  </Button>

                  <Button
                    color="blue"
                    size="tiny"
                    onClick={QueuePdfReport}
                  >
                    Queue PDF Report
                  </Button>
                </ListContainer>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Tracking Code</List.Header>
                  {templateDetails?.tracking_code}
                </ListContainer>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Template Id</List.Header>
                  {templateDetails?.template_id}
                </ListContainer>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Survey Id</List.Header>
                  {templateDetails?.debrief_schedule
                    ? templateDetails?.debrief_schedule
                    : "N/A"}
                </ListContainer>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Created</List.Header>
                  {templateDetails?.created_at &&
                    format(
                      new Date(templateDetails?.created_at),
                      "dd-MMM-yyyy hh:mm a"
                    )}
                </ListContainer>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <ListContainer>
                  <List.Header>Last Updated</List.Header>
                  {templateDetails?.updated_at &&
                    format(
                      new Date(templateDetails?.updated_at),
                      "dd-MMM-yyyy hh:mm a"
                    )}
                </ListContainer>
              </List.Content>
            </List.Item>
          </List>
        </Container>
      </SectionDiv>
      <SectionDiv>
        <ReactJson src={templateDetails?.params} />
      </SectionDiv>

      {/* Generated / LLM data exposed by the report (developer-facing) */}
      {templateDetails?.additional_info?.generated_data && (
        <SectionDiv>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 700 }}>Generated Data</div>
            <div style={{ color: '#6b7280', fontSize: 12 }}>{templateDetails?.additional_info?.generated_data?.metadata?.model || '—'}</div>
          </div>

          <div style={{ marginTop: 8, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 8 }}>
            <div style={{ padding: 8, background: '#fafaf9', borderRadius: 6 }}>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Metadata</div>
              <div style={{ color: '#374151', fontSize: 13 }}>Model: <strong style={{ marginLeft: 6 }}>{templateDetails?.additional_info?.generated_data?.metadata?.model || '—'}</strong></div>
              <div style={{ color: '#374151', fontSize: 13, marginTop: 6 }}>Saved to: <small style={{ color: '#6b7280' }}>{templateDetails?.additional_info?.generated_data?.metadata?.savedTo || '—'}</small></div>
              <div style={{ color: '#374151', fontSize: 13, marginTop: 6 }}>Processed at: <small style={{ color: '#6b7280' }}>{templateDetails?.additional_info?.generated_data?.metadata?.processedAt || '—'}</small></div>
              <div style={{ marginTop: 8, color: '#6b7280', fontSize: 12 }}>Anchor parent: {templateDetails?.additional_info?.generated_data?.metadata?.anchorParentName || '—'}</div>
            </div>

            <div style={{ padding: 8, background: '#fff', borderRadius: 6 }}>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Summary</div>
              <div style={{ color: '#374151', fontSize: 13 }}>
                {templateDetails?.additional_info?.generated_data?.llm_text_summary?.sections?.[0]?.summary || '—'}
              </div>
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            <ReactJson src={templateDetails?.additional_info?.generated_data} collapsed={2} name={false} />
          </div>
        </SectionDiv>
      )}
      <SectionDiv>
        <ReplacePdfFile 
          templateId={templateId} 
          currentFile={templateDetails?.download_files?.[0]}
          onUploadSuccess={() => {
            // Optionally refresh download link or other data
            dispatch({
              type: RESET_DEBRIEF_PDF_REPORT,
            });
          }}
        />
      </SectionDiv>
      <SectionDiv lastSection={true}>
        <Button floated="right" color="red" onClick={DeleteRow}>
          Delete Reports
        </Button>
      </SectionDiv>
      <SectionDiv>
        <DownloadFiles
          rows={templateDetails?.download_files}
          sharedWith={templateDetails?.share_report}
          RemoveFile={RemoveFile}
          GenerateLink={GenerateLink}
          ViewFile={ViewFile}
          downloadLink={downloadLink}
          additionalInfo={templateDetails?.additional_info}
        />
      </SectionDiv>
    </>
  );
};

export default Details;

function DownloadFiles({
  rows,
  sharedWith,
  RemoveFile,
  GenerateLink,
  ViewFile,
  downloadLink,
  additionalInfo,
}) {
  const isImage = (name = "", url = "") => {
    return (/\.(png|jpe?g|gif|webp|svg)$/i.test(name) || /\.(png|jpe?g|gif|webp|svg)$/i.test(url));
  };
  if (!rows) {
    return (
      <SectionDiv>
        <p>No files to download</p>
      </SectionDiv>
    );
  }

  return rows.map((row, index) => {
    return (
      <SectionDiv key={index} bordered>
        <SingleRowItem>
          <HeaderDiv>{row?.file_name}</HeaderDiv>
          <SingleRowContent>
            {downloadLink ? (
              <Button color="green" onClick={() => ViewFile(row?.share_id)}>
                View
              </Button>
            ) : (
              row?.file_name && (
                <Button
                  color="blue"
                  onClick={() => GenerateLink()}
                >
                  Download
                </Button>
              )
            )}
            {downloadLink?.url && isImage(row?.file_name, downloadLink?.url) && (
              <div style={{ marginTop: 12 }}>
                <img
                  src={downloadLink?.url}
                  alt={row?.file_name || "Preview"}
                  style={{ maxHeight: 300, borderRadius: 6, border: "1px solid #e5e7eb" }}
                  loading="lazy"
                />
              </div>
            )}
          </SingleRowContent>
        </SingleRowItem>

        <SingleRowItem>
          <SectionRow>Share Id</SectionRow>
          <SectionRow>{row?.share_id}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>Parent</SectionRow>
          <SectionRow>{row?.parent}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>Primary</SectionRow>
          <SectionRow>{JSON.stringify(row?.primary)}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>Category</SectionRow>
          <SectionRow>{row?.category}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>File Location</SectionRow>
          <SectionRow>{row?.file_location}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>File Name</SectionRow>
          <SectionRow>{row?.file_name}</SectionRow>
        </SingleRowItem>
        <SingleRowItem>
          <SectionRow>Shared With</SectionRow>
          <SectionRow>{JSON.stringify(sharedWith?.[row?.share_id])}</SectionRow>
        </SingleRowItem>
        <SectionDiv>
          {row?.file_name && (
            <Button
              floated="right"
              color="blue"
              onClick={() => RemoveFile(row?.share_id)}
            >
              Remove this file
            </Button>
          )}
        </SectionDiv>
        <SectionDiv>
          {/*
            additionalInfo may be either:
              - an array of objects (e.g. [{ share_id, ... }])
              - an object keyed by share_id (e.g. { "abcd": { ... } })
            Handle both safely and show a friendly message when nothing is available.
          */}
          {(() => {
            if (!additionalInfo) return <div style={{ color: '#6b7280' }}>No additional info</div>;
            // array case
            if (Array.isArray(additionalInfo)) {
              const matches = additionalInfo.filter((ai) => ai.share_id === row?.share_id);
              return matches.length ? (
                <ReactJson src={matches} collapsed={1} name={false} />
              ) : (
                <div style={{ color: '#6b7280' }}>No additional info for this file</div>
              );
            }

            // object / map case
            if (typeof additionalInfo === 'object') {
              // if keyed by share_id
              const obj = additionalInfo[row?.share_id] || null;
              if (obj) return <ReactJson src={obj} collapsed={1} name={false} />;

              // fallback: show whole object if it contains generated_data (present for the whole report)
              if (additionalInfo.generated_data) return <ReactJson src={additionalInfo} collapsed={2} name={false} />;

              return <div style={{ color: '#6b7280' }}>No per-file additional info found</div>;
            }

            // anything else - just show JSON
            return <ReactJson src={additionalInfo} collapsed={2} name={false} />;
          })()}
        </SectionDiv>
      </SectionDiv>
    );
  });
}

const SectionDiv = styled.div`
  margin: 10px 0px;
  margin-bottom: ${(props) => (props.lastSection === true ? "100px" : "20px")};
  border: ${(props) =>
    props.bordered === true ? "1px solid #dcdcdc;" : "none"};
  padding: ${(props) => (props.bordered === true ? "20px;" : " 10px 0px;")};
`;

const Container = styled.div`
  display: flex;
`;

const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`;

const HeaderDiv = styled.div`
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 20px; /* Padding for header */
`;

const SingleRowContent = styled.div`
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SingleRowItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

const SectionRow = styled.div`
  align-self: flex-start; /* Align left */
  margin-right: 10px;
  min-width: 150px;
`;

/* SectionCell intentionally removed (unused) */
